import React from 'react';

import { FormItem } from '../shared/FormItem';
import { Select, SelectProps } from './Select';

type SelectItemProps = {
  label: string;
  required?: boolean;
  error?: string;
  tooltip?: React.ReactNode;
  'data-testid': string;
} & Omit<SelectProps, 'hasError'>;

export const SelectItem = React.forwardRef<HTMLSelectElement, SelectItemProps>(
  (props, ref) => {
    const { name, required, error, label, tooltip, ...selectProps } = props;

    return (
      <FormItem
        name={name}
        label={label}
        tooltip={tooltip}
        required={required}
        error={error}
        dataTestId={`${selectProps['data-testid']}-wrapper`}
      >
        <Select
          ref={ref}
          id={name}
          name={name}
          hasError={!!error}
          required={required}
          {...selectProps}
        />
      </FormItem>
    );
  }
);

SelectItem.displayName = 'SelectWrapped';
